import '~/bootstrap'

import { createApp } from 'vue';
import Scripture from '~/components/Scripture.vue';


const scriptureVue = createApp(Scripture).mount("#scripture-container");

